import React, { useEffect } from 'react';
import { Link, useLocation, matchPath } from 'react-router-dom';
import {
  Box,
  Tabs,
  Tab,
  Paper,
  createTheme,
  ThemeProvider,
  CssBaseline,
} from '@mui/material';
import {
  CompareArrows as MigrateIcon,
  Home as HomeIcon,
  Balance as CloneIcon,
} from '@mui/icons-material';
import config from "../../../src/env.json"; 

interface KeyvaultProps {
 
}

const theme = createTheme({
  palette: {
    primary: { main: "#673AB7" },
    secondary: { main: '#dc004e' },
  },
});

const Keyvault: React.FC<KeyvaultProps> = () => {
  const location = useLocation();

  const menuItems = [
    { text: 'All Keyvaults', icon: <HomeIcon fontSize="small" />, path: '/Keyvaults' },
    { text: 'Migration Tool', icon: <MigrateIcon fontSize="small" />, path: '/Keyvaults/migrate' },
    { text: 'Clone Vault', icon: <CloneIcon fontSize="small" />, path: '/Keyvaults/clone' },
  ];

  const activeTabIndex = menuItems.findIndex((item) => 
    matchPath({ path: item.path, end: true }, location.pathname) || 
    location.pathname === item.path
  );
  const currentTab = activeTabIndex === -1 ? 0 : activeTabIndex;

  useEffect(() => {
    document.documentElement.style.setProperty('--primary-color', config.REACT_APP_MAIN_APP_CSS_PRIMARY_COLOR || '#1976d2');
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ width: '100%', mb: 3 }}>
        <Paper 
            elevation={0} 
            sx={{ 
                borderBottom: 1, 
                borderColor: 'divider',
                backgroundColor: 'transparent',
                display: 'flex',
                alignItems: 'center',
                pr: 2 
            }}
        >
          <Tabs value={currentTab} textColor="primary" indicatorColor="primary">
            {menuItems.map((item) => (
              <Tab
                key={item.text}
                label={item.text}
                icon={item.icon}
                iconPosition="start"
                component={Link}
                to={item.path}
                sx={{ textTransform: 'none', fontWeight: 600, minHeight: 48, zIndex: 2, }}
              />
            ))}
          </Tabs>

          
        </Paper>
      </Box>
    </ThemeProvider>
  );
};

export default Keyvault;
